import cn from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
/* eslint-disable react/prop-types */ var RightControlsWrapper = function(param) {
    var children = param.children;
    var rightMenu = useSelector(function(state) {
        return state.layout;
    }).rightMenu;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn('right-controls-wrapper', rightMenu.isVisible && 'open')
    }, children);
};
export default RightControlsWrapper;
